import styled from "@emotion/styled";
import { Container } from "@mui/material";

export const StyledPolicyContentSectionContainer = styled(Container)(({ theme }) => ({
  paddingBottom: "4rem",
  [theme.breakpoints.up("lg")]: {
    paddingBottom: "6rem",
  },
}));
